export default __webpack_public_path__ + "static/avatar-jules-40110d9579a6b216216132dd9c890701.png";